import {createFeatureSelector, createSelectorFactory, MemoizedProjection} from '@ngrx/store';
import { State } from './generic-texts.reducer';
import {AnyFn} from '@ngrx/store/src/selector';

export const getGenericTextsFeature = createFeatureSelector<State>('genericTexts');

export function isEqual(a: any, b: any): boolean {
    return a.totalRows === b.totalRows &&
        a.genericTexts.every(fromA => b.genericTexts.includes(fromA));
}

export function customMemoize(t: AnyFn): MemoizedProjection {
    let lastResult: any = null;

    function memoized(): any {
        const result = t.apply(null, arguments);

        if (lastResult == null || !isEqual(result, lastResult)) {
            lastResult = result;
            return result;
        }
        return lastResult;
    }

    function reset() { lastResult = null; }

    return {
        clearResult(): void {
        }, setResult(result: any): void {
        }, memoized, reset};
}

export const getGenericTexts = createSelectorFactory(customMemoize)(
    getGenericTextsFeature,
    (state) => {
        return {
            genericTexts: state.genericTexts,
            totalRows: state.totalRows,
            currentLazyLoad: state.currentLazyLoad
        };
    }
);
